import { render, staticRenderFns } from "./SpecialMealConfig.vue?vue&type=template&id=2afe9634&scoped=true"
import script from "./SpecialMealConfig.vue?vue&type=script&lang=js"
export * from "./SpecialMealConfig.vue?vue&type=script&lang=js"
import style0 from "./SpecialMealConfig.vue?vue&type=style&index=0&id=2afe9634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afe9634",
  null
  
)

export default component.exports